import React from "react";
import PanelMainInner from "../../PanelMainInner";
import ListCounseling from "./ListCounseling";

const CounselingSections:React.FC = () => {
    return(
        <PanelMainInner title={"مشاوره ها"} isBg={true}>
            <ListCounseling />
        </PanelMainInner>
    )
}

export default CounselingSections